import { render, staticRenderFns } from "./AddVisitor.vue?vue&type=template&id=d20c7b52&scoped=true&"
import script from "./AddVisitor.vue?vue&type=script&lang=js&"
export * from "./AddVisitor.vue?vue&type=script&lang=js&"
import style0 from "./AddVisitor.vue?vue&type=style&index=0&id=d20c7b52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20c7b52",
  null
  
)

export default component.exports